import React from "react";
import Sidebar from "../../../components/Sidebar";
import BookAppointmentCheckoutForm from "../../../components/forms/BookAppointmentCheckoutForm";

const CheckoutPage = () => {
  return (
    <Sidebar>
      <BookAppointmentCheckoutForm />
    </Sidebar>
  );
};

export default CheckoutPage;
